<template>
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7L4 4L7 7" stroke="currentColor" stroke-width="2"/>
        <path d="M4 4L1 1" stroke="currentColor" stroke-width="2"/>
        <path d="M4 4L7 1" stroke="currentColor" stroke-width="2"/>
    </svg>

</template>

<script>
    export default {
        name: "SVGCrossClearField"
    }
</script>

<style scoped>

</style>
